import React, { FC } from 'react';
import cn from 'classnames';
import { CdnIcon } from '@shared/ui';
import CdnImage from '../../../../../CdnImage/CdnImage';
import { EngineTheme, useTheme, useMergeClasses } from '../../../../../theme';
import { Tooltip } from '../../../../../BaseComponents';
import { RestrictionsType } from '../model/types';

interface Props extends RestrictionsType {
	classes?: EngineTheme['Shared']['Restrictions'];
}

const Restrictions: FC<Props> = ({ classes, variant = 'forbidden', title, subtitle, img, list }) => {
	const { Restrictions: defaultClasses } = useTheme('Shared');
	const css = useMergeClasses(defaultClasses, classes);

	const showList = !!list && list.length > 0;

	return (
		<div
			className={cn(css.root, {
				[css.forbidden]: variant === 'forbidden',
				[css.allowed]: variant === 'allowed'
			})}
		>
			<div className={css.header}>
				<CdnIcon
					className={css.header__icon}
					icon={variant === 'forbidden' ? 'Info/Cancel' : 'Info/Item Icluded'}
				/>

				<div className={css.title__wrapper}>
					<div className={css.title}>{title}</div>
					{!!subtitle && <div className={css.subtitle}>{subtitle}</div>}
				</div>
			</div>

			<div className={css.line} />

			<div className={css.content}>
				{!!img && <CdnImage className={css.image} path={img} />}

				{showList && (
					<div className={css.list}>
						{list.map((item, index) => (
							<div key={index} className={css.item}>
								<div className={css.item__title}>{item.title}</div>

								{!!item.description && (
									<Tooltip
										title={item.description}
										titleClassName={css.item__description}
										tooltipClassName={css.item__tooltip}
										arrowClassName={css.item__tooltip_arrow}
										enterTouchDelay={0}
									>
										<div>
											<CdnIcon className={css.item__icon} icon="Info/Question" />
										</div>
									</Tooltip>
								)}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default Restrictions;
